import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import { expEmail } from "@utils/expression";
import { apiSend, getRoute } from "@services/axios";
import { useParams } from "react-router-dom";
function RecoverPassword() {
  const { t } = useTranslation();
  const token = useParams().token;
  const [loading, setLoading] = useState(false);

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  var itemEmail = {
    type: "text",
    placeholder: t("email"),
    messageError: t("invalid_email"),
    className: "input-blue text-dark w-100 p-4 border fw-light ",
    size: "md",
    rules: {
      required: t("mandatory"),
      pattern: {
        value: expEmail,
        message: t("invalid_format"),
      },
    },
  };

  var itemPassword = {
    type: "password",
    messageError: t("password_required"),
    placeholder: t("password"),
    className: "input-blue text-dark w-100 p-4 border fw-light ",
    size: "md",
    rules: {
      required: t("mandatory"),
    },
  };

  var itemPasswordConfirm = {
    type: "password",
    messageError: t("password_required"),
    placeholder: t("password"),
    className: "input-blue text-dark w-100 p-4 border fw-light ",
    size: "md",
    rules: {
      required: t("mandatory"),
    },
  };

  const onLogin = async (data) => {
    setLoading(true);
    const res = await apiSend(
      [getRoute("RESET_PASWORD"), token].join("/"),
      "post",
      data
    );
    alert(res?.data?.result?.message);
    if (res?.data?.request?.status === true) {
      var url = ["/login"];
      window.location = url.join("/");
    }

    setLoading(false);
  };

  return (
    <Form as="div" className="login-bg">
      <Form as="div" className="login-container w-50 p-5">
        <Form as="h2" className="fs-4 text-center mb-5">
          password update
        </Form>
        <Form onSubmit={handleSubmit(onLogin)}>
          <Row className="mb-3">
            <Form as="div" className="my-3">
              <IController
                elment={`email`}
                item={itemEmail}
                control={control}
                errors={errors}
                register={register}
              />
            </Form>
            <Form as="div" className="my-3">
              <IController
                elment={`password`}
                item={itemPassword}
                control={control}
                errors={errors}
                register={register}
              />
            </Form>
            <Form as="div" className="my-3">
              <IController
                elment={`password_confirmation`}
                item={itemPasswordConfirm}
                control={control}
                errors={errors}
                register={register}
              />
            </Form>
            <Form
              as="button"
              type="submit"
              className="btn-blue p-4 rounded-5 fw-bold"
            >
              {loading ? (
                <Form
                  as="span"
                  className="spinner-border spinner-border-sm m-1"
                ></Form>
              ) : (
                t("reset")
              )}
            </Form>
          </Row>
        </Form>
      </Form>
    </Form>
  );
}

export default RecoverPassword;
